import React, {
  useMemo,
  useEffect,
  useCallback,
  useState
} from 'react';
import { Column, ColumnFixing, HeaderFilter } from 'devextreme-react/data-grid';
import {
  Button, SelectBox, Template,
  TextBox
} from 'devextreme-react';
import { CheckBox } from 'devextreme-react/check-box';
import {
  Validator,
  RequiredRule,
  StringLengthRule
} from 'devextreme-react/validator';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import SplitterLayout from 'react-splitter-layout';
import 'react-splitter-layout/lib/index.css';

import DataGridMVP from '../../DataGridMVP';
import PopupMVP from '../../PopupMVP';

import style from './userrole.module.scss';
import columnDataGridUser from './columnDataGridUser';
import columnDataGridRole from './columnDataGridRole';
import columnDataGridPermission from './columnDataGridPermission';

const initDataRole = {
  roleId: null,
  roleName: null,
  description: null
};

const initDataCreateRole = {
  roleName: '',
  description: ''
};

const UserRole = ({
  selectedIndex,
  adminReducer: {
    loadingUser,
    loadingRole,
    loadingPermissions,
    loadingPermissionValues,
    listUsersOnRole,
    listRoles,
    listPermissionsOnRole,
    listPermissions,
    listPermissionValues,
    dataEditRole,
    dataCreateRole,
    dataAddPermission,
    dataDelPermission
  },
  getUsersOnRole,
  getRolesList,
  createRole,
  createRoleClear,
  updateRole,
  updateRoleClear,
  getPermissionsOnRole,
  getPermissions,
  getPermissionValues,
  addPermissionOnRole,
  addPermissionOnRoleClear,
  deletePermissionOnRole,
  deletePermissionOnRoleClear
}) => {
  const [selectedRowsDataRole, setSelectedRowsDataRole] = useState([]);
  const [visibleModalEditRole, setVisibleModalEditRole] = useState(false);
  const [visibleModalAddPermission, setVisibleModalAddPermission] = useState(false);
  const [visibleModalDelPermission, setVisibleModalDelPermission] = useState(false);
  const [selectPermissionAddRole, setSelectPermissionAddRole] = useState(null);
  const [selectPermissionValueAddRole, setSelectPermissionValueAddRole] = useState(null);
  const [selectPermissionDelRole, setSelectPermissionDelRole] = useState(null);
  const [dataRole, setDataRole] = useState(initDataRole);
  const [visibleModalCreateRole, setVisibleModalCreateRole] = useState(false);
  const [createRoleForm, setCreateRoleForm] = useState(initDataCreateRole);

  useEffect(() => {
    if (selectedIndex === 1) {
      getRolesList();
      getPermissions();
    }
  }, [
    selectedIndex,
    getPermissions,
    getRolesList
  ]);

  useEffect(() => {
    if (
      visibleModalEditRole
      && dataEditRole.okRequest
    ) {
      setVisibleModalEditRole(false);
      updateRoleClear();
    }
  }, [
    visibleModalEditRole,
    dataEditRole.okRequest,
    updateRoleClear
  ]);

  useEffect(() => {
    if (
      visibleModalAddPermission
      && dataAddPermission.okRequest
    ) {
      setVisibleModalAddPermission(false);
      addPermissionOnRoleClear();
    }
  }, [
    addPermissionOnRoleClear,
    visibleModalAddPermission,
    dataAddPermission.okRequest
  ]);

  useEffect(() => {
    if (
      visibleModalDelPermission
      && dataDelPermission.okRequest
    ) {
      setVisibleModalDelPermission(false);
      deletePermissionOnRoleClear();
    }
  }, [
    deletePermissionOnRoleClear,
    visibleModalDelPermission,
    dataDelPermission.okRequest
  ]);

  useEffect(() => {
    if (
      visibleModalCreateRole
      && dataCreateRole.okRequest
    ) {
      setVisibleModalCreateRole(false);
      createRoleClear();
    }
  }, [
    createRoleClear,
    visibleModalCreateRole,
    dataCreateRole.okRequest
  ]);

  const onHidingModalEditRole = useCallback(() => {
    setVisibleModalEditRole(false);
  }, []);

  const onHidingModalCreateRole = useCallback(() => {
    setVisibleModalCreateRole(false);
  }, []);

  const openModalEditRole = useCallback((data = initDataRole) => {
    setDataRole({
      ...data
    });
    setVisibleModalEditRole(true);
  }, [
    setDataRole
  ]);

  const openModalCreateRole = useCallback(() => {
    setVisibleModalCreateRole(true);
    setCreateRoleForm(initDataCreateRole);
  }, [
    setCreateRoleForm
  ]);

  const sendSaveEditRole = useCallback(() => {
    updateRole(dataRole);
  }, [updateRole, dataRole]);

  const sendCreateRole = useCallback(() => {
    createRole(createRoleForm);
  }, [createRole, createRoleForm]);

  const openModalAddPermission = useCallback(() => {
    setVisibleModalAddPermission(true);
    setSelectPermissionAddRole(null);
    setSelectPermissionValueAddRole(null);
  }, []);

  const onHidingModalAddPermission = useCallback(() => {
    setVisibleModalAddPermission(false);
  }, []);

  const onValueChangePermission = useCallback(({ value }) => {
    if (value && value !== selectPermissionAddRole) {
      setSelectPermissionAddRole(value);
      setSelectPermissionValueAddRole(null);
      getPermissionValues({ permId: value.spNumId });
    }
  }, [getPermissionValues, selectPermissionAddRole]);

  const sendSaveAddPermission = useCallback(() => {
    addPermissionOnRole({
      roleId: selectedRowsDataRole[0].roleId,
      spvId: selectPermissionValueAddRole.spvNumId
    });
  }, [
    addPermissionOnRole,
    selectPermissionValueAddRole,
    selectedRowsDataRole
  ]);

  const openModalDelPermission = useCallback((data) => {
    setSelectPermissionDelRole(data.data);
    setVisibleModalDelPermission(true);
  }, [
    setSelectPermissionDelRole
  ]);

  const onHidingModalDelPermission = useCallback(() => {
    setVisibleModalDelPermission(false);
  }, []);

  const sendSaveDelPermission = useCallback(() => {
    deletePermissionOnRole({
      srpId: selectPermissionDelRole.srpNumId,
      roleId: selectedRowsDataRole[0].roleId
    });
  }, [
    deletePermissionOnRole,
    selectPermissionDelRole,
    selectedRowsDataRole
  ]);

  const renderButtonDelPermission = useMemo(() => (data) => (
    <Button type="default"
            stylingMode="text"
            icon="trash"
            onClick={() => openModalDelPermission(data)}
    />
  ), [openModalDelPermission]);

  const toolbarButtonAddPermission = useMemo(() => () => (
    <Button type="default"
            stylingMode="contained"
            icon="plus"
            text="Добавить"
            elementAttr={{ class: style.buttonAdd }}
            disabled={!selectedRowsDataRole.length}
            onClick={openModalAddPermission}
    />
  ), [selectedRowsDataRole, openModalAddPermission]);

  const onSelectRole = useCallback(({ selectedRowsData }) => {
    setSelectedRowsDataRole(selectedRowsData);
    if (selectedRowsData && selectedRowsData.length) {
      getUsersOnRole({ roleId: selectedRowsData[0].roleId });
      getPermissionsOnRole({ roleId: selectedRowsData[0].roleId });
    }
  }, [getUsersOnRole, getPermissionsOnRole]);

  const renderButtonEditRole = useMemo(() => (data) => (
    <Button type="default"
            stylingMode="text"
            icon="edit"
      /* eslint-disable-next-line react/destructuring-assignment */
            onClick={() => openModalEditRole(data.data)}
    />
  ), [openModalEditRole]);

  const cellRenderDeletedFlag = useMemo(() => (data) => {
    // eslint-disable-next-line react/destructuring-assignment
    if (data.value === 'Y') {
      return <CheckBox defaultValue />;
    }
    return <CheckBox defaultValue={false} />;
  }, []);

  const renderColumnDataGridUser = useMemo(
    () =>
      columnDataGridUser.map((item) => (
        <Column
          dataField={item.dataField}
          key={item.dataField}
          caption={item.caption}
          visible
          allowFiltering
          width={item.width}
          cellRender={item.cellRender && cellRenderDeletedFlag}
          dataType={item.dataType}
          allowSearch={!item.notAllowSearch}
          sortOrder={item.sortOrder}
        >
          {item.headerFilter && (
            <HeaderFilter dataSource={[
              {
                text: 'Да',
                value: [item.dataField, '=', 'Y']
              },
              {
                text: 'Нет',
                value: [item.dataField, '=', 'N']
              }
            ]}
            />
          )}
        </Column>
      )),
    [cellRenderDeletedFlag]
  );

  const renderUserList = useMemo(() => (
    <DataGridMVP className="shipment"
                 setStateStoringName="dataGridUserList"
                 keyExpr="userId"
                 visibleButtonDateRangePicker={false}
                 visibleSummary={false}
                 visibleGroupPanel={false}
                 visibleInfoIcon={false}
                 dataSource={listUsersOnRole}
                 loadingData={loadingUser}
                 filterDataGrid
                 selectionMode="single"
    >
      <ColumnFixing enabled />
      {renderColumnDataGridUser}
    </DataGridMVP>
  ), [
    renderColumnDataGridUser,
    loadingUser,
    listUsersOnRole
  ]);

  const renderColumnDataGridRole = useMemo(
    () =>
      columnDataGridRole.map((item) => (
        <Column
          dataField={item.dataField}
          key={item.dataField}
          caption={item.caption}
          visible
          allowFiltering
          dataType={item.dataType}
          width={item.width}
        />
      )),
    []
  );

  const toolbarButtonCreateRole = useMemo(() => () => (
    <Button type="default"
            stylingMode="contained"
            icon="plus"
            text="Добавить"
            // elementAttr={{ class: style.buttonAdd }}
            onClick={() => openModalCreateRole()}
    />
  ), [openModalCreateRole]);

  const renderRoleList = useMemo(() => (
    <DataGridMVP className="shipment"
                 setStateStoringName="dataGridRoleList"
                 keyExpr="roleId"
                 visibleButtonDateRangePicker={false}
                 visibleSummary={false}
                 visibleGroupPanel={false}
                 visibleInfoIcon={false}
                 visibleButtonAddResponsiblePerson
                 dataSource={listRoles}
                 loadingData={loadingRole}
                 filterDataGrid
                 selectionMode="single"
                 onSelectionChanged={onSelectRole}
    >
      <ColumnFixing enabled />
      {renderColumnDataGridRole}
      <Column cellRender={renderButtonEditRole}
              width={75}
              fixed
              fixedPosition="right"
      />
      <Template name="toolbarButtonAddResponsiblePerson" render={toolbarButtonCreateRole} />
    </DataGridMVP>
  ), [
    loadingRole,
    onSelectRole,
    listRoles,
    renderButtonEditRole,
    renderColumnDataGridRole,
    toolbarButtonCreateRole
  ]);

  const renderColumnDataGridPermission = useMemo(
    () =>
      columnDataGridPermission.map((item) => (
        <Column
          dataField={item.dataField}
          key={item.dataField}
          caption={item.caption}
          visible
          allowFiltering
          dataType={item.dataType}
          width={item.width}
          cellRender={item.cellRender}
        />
      )),
    []
  );
  const renderPermissionList = useMemo(() => (
    <DataGridMVP className="shipment"
                 setStateStoringName="dataGridRoleList"
                 keyExpr="srpNumId"
                 visibleButtonDateRangePicker={false}
                 visibleSummary={false}
                 visibleGroupPanel={false}
                 visibleInfoIcon={false}
                 visibleButtonAddResponsiblePerson
                 dataSource={listPermissionsOnRole}
                 loadingData={loadingPermissions}
                 isDataLoading={loadingPermissions}
                 filterDataGrid
                 selectionMode="single"
    >
      <ColumnFixing enabled />
      {renderColumnDataGridPermission}
      <Column cellRender={renderButtonDelPermission}
              width={75}
              fixed
              fixedPosition="right"
      />
      <Template name="toolbarButtonAddResponsiblePerson" render={toolbarButtonAddPermission} />
    </DataGridMVP>
  ), [
    loadingPermissions,
    listPermissionsOnRole,
    renderColumnDataGridPermission,
    toolbarButtonAddPermission,
    renderButtonDelPermission
  ]);

  const renderModalEditRole = useMemo(() => (
    <PopupMVP visible={visibleModalEditRole}
              onHiding={onHidingModalEditRole}
              title="Редактирование роли"
    >
      <div className="formData">
        <div className="optionsRow">
          <div className="optionsData">
            <span>
              Название
              <sup>*</sup>
            </span>
            <TextBox stylingMode="outlined"
                     placeholder="Введите название роли"
                     value={dataRole.roleName}
                     onValueChanged={({ value }) => {
                       setDataRole((item) => ({
                         ...item,
                         roleName: value
                       }));
                     }}
            >
              <Validator>
                <RequiredRule message="Обязательно для заполнения" />
                <StringLengthRule message="Обязательно для заполнения" min={2} />
              </Validator>
            </TextBox>
          </div>
        </div>
        <div className="optionsRow">
          <div className="optionsData">
            <span>
              Описание
              <sup>*</sup>
            </span>
            <TextBox stylingMode="outlined"
                     placeholder="Введите описание роли"
                     value={dataRole.description}
                     onValueChanged={({ value }) => {
                       setDataRole((item) => ({
                         ...item,
                         description: value
                       }));
                     }}
            >
              <Validator>
                <RequiredRule message="Обязательно для заполнения" />
                <StringLengthRule message="Обязательно для заполнения" min={2} />
              </Validator>
            </TextBox>
          </div>
        </div>
        <div className="formButton">
          <Button text="Отмена"
                  type="default"
                  stylingMode="text"
                  onClick={onHidingModalEditRole}
          />
          <Button type="default"
                  stylingMode="contained"
                  onClick={sendSaveEditRole}
                  width={200}
          >
            <LoadIndicator className="indicator" visible={dataEditRole.loading} />
            <span>Сохранить</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    visibleModalEditRole,
    onHidingModalEditRole,
    dataRole,
    sendSaveEditRole,
    dataEditRole.loading
  ]);

  const renderModalAddPermission = useMemo(() => (
    <PopupMVP visible={visibleModalAddPermission}
              onHiding={onHidingModalAddPermission}
              title="Добавить права"
    >
      <div className="formData">
        <div className="optionsData">
          <span>Список типов прав</span>
          <SelectBox stylingMode="outlined"
                     items={listPermissions}
                     displayExpr="permDescription"
                     searchEnabled
                     value={selectPermissionAddRole}
                     onValueChanged={onValueChangePermission}
          />
        </div>
        <div className="optionsData">
          <span>Список значений</span>
          <SelectBox stylingMode="outlined"
                     dataSource={listPermissionValues}
                     displayExpr="valueDescription"
                     searchEnabled
                     disabled={!(selectPermissionAddRole && !loadingPermissionValues)}
                     value={selectPermissionValueAddRole}
                     onValueChanged={({ value }) => setSelectPermissionValueAddRole(value)}
          />
        </div>
        <div className="formButton">
          <Button text="Отмена"
                  type="default"
                  stylingMode="text"
                  onClick={onHidingModalAddPermission}
          />
          <Button type="default"
                  stylingMode="contained"
                  onClick={sendSaveAddPermission}
                  width={200}
                  disabled={!selectPermissionValueAddRole}
          >
            <LoadIndicator className="indicator" visible={dataAddPermission.loading} />
            <span>Сохранить</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    visibleModalAddPermission,
    onHidingModalAddPermission,
    listPermissions,
    selectPermissionAddRole,
    onValueChangePermission,
    listPermissionValues,
    selectPermissionValueAddRole,
    loadingPermissionValues,
    sendSaveAddPermission,
    dataAddPermission.loading
  ]);

  const renderModalDelPermission = useMemo(() => (
    <PopupMVP visible={visibleModalDelPermission}
              onHiding={onHidingModalDelPermission}
              title="Удаление прав"
    >
      <div className="formData">
        <span>
          Удалить права
          <b>{` "${selectPermissionDelRole && selectPermissionDelRole.permDescription}" `}</b>
          со значением
          <b>{` "${selectPermissionDelRole && selectPermissionDelRole.valueDescription}" `}</b>
          у роли
          <b>{` "${selectedRowsDataRole.length && selectedRowsDataRole[0].roleName}" `}</b>
          ?
        </span>
        <div className="formButton">
          <Button text="Отмена"
                  type="default"
                  stylingMode="text"
                  onClick={onHidingModalDelPermission}
          />
          <Button type="default"
                  stylingMode="contained"
                  onClick={sendSaveDelPermission}
                  width={200}
          >
            <LoadIndicator className="indicator" visible={dataDelPermission.loading} />
            <span>Удалить</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    visibleModalDelPermission,
    onHidingModalDelPermission,
    selectPermissionDelRole,
    selectedRowsDataRole,
    sendSaveDelPermission,
    dataDelPermission.loading
  ]);

  const renderModalCreateRole = useMemo(() => (
    <PopupMVP visible={visibleModalCreateRole}
              onHiding={onHidingModalCreateRole}
              title="Добавление роли"
    >
      <div className="formData">
        <div className="optionsRow">
          <div className="optionsData">
            <span>
              Название
              <sup>*</sup>
            </span>
            <TextBox stylingMode="outlined"
                     placeholder="Введите название роли"
                     value={createRoleForm.roleName}
                     onValueChanged={({ value }) => {
                       setCreateRoleForm((item) => ({ ...item, roleName: value }));
                     }}
                     valueChangeEvent="input"
            />
          </div>
        </div>
        <div className="optionsRow">
          <div className="optionsData">
            <span>
              Описание
              <sup>*</sup>
            </span>
            <TextBox stylingMode="outlined"
                     placeholder="Введите описание роли"
                     value={createRoleForm.description}
                     onValueChanged={({ value }) => {
                       setCreateRoleForm((item) => ({ ...item, description: value }));
                     }}
                     valueChangeEvent="input"
            />
          </div>
        </div>
        <div className="formButton">
          <Button text="Отмена"
                  type="default"
                  stylingMode="text"
                  onClick={onHidingModalCreateRole}
          />
          <Button type="default"
                  stylingMode="contained"
                  onClick={sendCreateRole}
                  width={200}
                  disabled={!createRoleForm.roleName.trim() || !createRoleForm.description.trim()}
          >
            <LoadIndicator className="indicator" visible={dataCreateRole.loading} />
            <span>Сохранить</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    visibleModalCreateRole,
    onHidingModalCreateRole,
    createRoleForm,
    sendCreateRole,
    dataCreateRole.loading
  ]);

  return (
    <div className={style.containing}>
      <SplitterLayout>
        <div>
          <p>
            <b>Список ролей</b>
          </p>
          {renderRoleList}
          {renderModalCreateRole}
        </div>
        <div>
          <p>
            <b>Пользователи с ролью</b>
            {`${selectedRowsDataRole.length ? `: ${selectedRowsDataRole[0].roleName} ` : ''}`}
          </p>
          {renderUserList}

          <p>
            <b>Права</b>
            {`${selectedRowsDataRole.length ? `: ${selectedRowsDataRole[0].roleName} ` : ''}`}
          </p>
          {renderPermissionList}
        </div>
      </SplitterLayout>
      {renderModalEditRole}
      {renderModalAddPermission}
      {renderModalDelPermission}
    </div>
  );
};

export default UserRole;
